import { createTheme, ThemeOptions } from '@material-ui/core'

import { adminThemeBreakpoints } from './breakpoints'
import {
  adminLightPlaceholder,
  adminThemeDefaultProps,
  adminThemeStatus,
  adminThemeZIndex,
} from './customThemeProperties'
import { overrides } from './overrides'
import { adminLightPalette, basePalette, dataVizPalette } from './palette'
import { adminThemeTypography } from './typography'

export const adminLightOptions = {
  themeName: 'Admin Light',
  palette: {
    ...basePalette,
    ...adminLightPalette,
    ...dataVizPalette,
  },
  breakpoints: adminThemeBreakpoints,
  typography: adminThemeTypography,
  overrides: overrides,
  /** Legacy Properties. Avoid new usage. */
  ...adminLightPlaceholder,
  ...adminThemeZIndex,
  ...adminThemeStatus,
  ...adminThemeDefaultProps,
} satisfies ThemeOptions

export const adminLight = /* @__PURE__ */ createTheme(adminLightOptions)
